"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _MarketOverview = _interopRequireDefault(require("../../components/MarketOverview"));
require("./MarketOverviewLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var marketOverviewLayoutClasses = (0, _cssClassesHelper.getBEMClasses)('market-overview-layout');
var MarketOverviewLayout = function MarketOverviewLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: marketOverviewLayoutClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: marketOverviewLayoutClasses('header')
  }, t('Markets Overview')), /*#__PURE__*/_react["default"].createElement(_MarketOverview["default"], null));
};
var _default = exports["default"] = MarketOverviewLayout;